import { MAX_CHARACTER_INPUT_VALIDATION } from "@/constants/common";
import { validator } from "@/utils/validator";
import { useMemo } from "react";

export const useGetMatchSchema = () => {
  const matchSchema = useMemo(() => {
    return validator.object().shape({
      matchName: validator.string().trim().emptyToNull().max(60).label("会社名").nameOnly().required(),
      licenseNumber: validator
        .string()
        .trim()
        .emptyToNull()
        .label("紹介事業許可番号")
        .matches(/^\d{2}-ユ-\d{6}$/, "無効な許可番号の形式です。期待される形式: YY-ユ-XXXXXX"),
      zipCode: validator
        .string()
        .emptyToNull()
        .autoTransformToHalfWidth()
        .zipCode()
        .trim()
        .label("郵便番号")
        .notRequired()
        .max(MAX_CHARACTER_INPUT_VALIDATION),
      prefecture: validator.string().trim().emptyToNull().label("都道府県").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION),
      city: validator.string().trim().emptyToNull().label("市区町村").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION),
      address: validator.string().emptyToNull().nullable().label("町名丁目番地号等").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION).trim(),
      matchOffices: validator
        .array()
        .of(
          validator.object().shape({
            officeName: validator.string().trim().emptyToNull().label("事業所名").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION),
            fullName: validator.string().trim().emptyToNull().nameOnly().label("氏名").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION),
            trainingDate: validator.mixed().isDayjs().isSelection().nullable().notRequired().label("講習受講日"),
          }),
        )
        .test("first-office-name-required", function (value) {
          if (value && value.length > 0 && !value[0]?.officeName) {
            return this.createError({
              path: `${this.path}[0].officeName`,
              message: "「事業所名」を入力してください。",
            });
          }
          return true;
        })
        .label("職業紹介責任者情報")
        .notRequired(),
    });
  }, []);

  return { matchSchema };
};
